import { paymentDocumentsAPI } from '../../api';

const state = () => ({
    filterOptions: {
        createdBy: [],
        status: [
            { text: 'Open', value: 'Open' },
            { text: 'Payment Processing', value: 'PaymentProcessing' },
            { text: 'Payment Proposal Created', value: 'PaymentProposalCreated' },
            { text: 'Payment Proposal Released', value: 'PaymentProposalReleased' },
            { text: 'Payment Failed', value: 'PaymentFailed' },
            { text: 'Under Review', value: 'UnderReview' },
            { text: 'Inactive', value: 'Inactive' },
            { text: 'Payment Completed', value: 'PaymentCompleted' },
            { text: 'Payment Completed Partially', value: 'PaymentCompletedPartially' },
            { text: 'Reversal Requested', value: 'ReversalRequested' },
            { text: 'Action Required', value: 'ActionRequired' },
            { text: 'Payment Proposal Deletion Failed', value: 'PaymentProposalDeletionFailed' },
            { text: 'Payment Proposal Creation Failed', value: 'PaymentProposalCreationFailed' },
        ],
        paymentType: [
            { text: 'Clearing Proposal', value: 'ManualPaymentProposal' },
            { text: 'Free Form Payment', value: 'FreeFormPayment' },
            { text: 'No Payment', value: 'NoPayment' },
            { text: 'Normal Proposal', value: 'AutomaticPaymentProposal' },
            { text: 'Manual Payment (No Proposal)', value: 'ManualPayment' },
        ],
    },
});

const mutations = {
    setFilterOptions(state, data) {
        state.filterOptions.createdBy = data.createdBy;
    },
};

const actions = {
    async getCompanyCodes() {
        const response = await paymentDocumentsAPI.getCompanyCodesAPI();
        return response.data;
    },
    // async createPaymentInformation(_, data) {
    //     const response = await paymentDocumentsAPI.createPaymentInformationAPI(data);
    //     return response.data;
    // },
    async updatePaymentInformation(_, { paymentDocumentId, data }) {
        const response = await paymentDocumentsAPI.updatePaymentInformationAPI(paymentDocumentId, data);
        return response.data;
    },
    async updatePaymentDocumentType(_, { paymentDocumentId, data }) {
        const response = await paymentDocumentsAPI.updatePaymentDocumentTypeAPI(paymentDocumentId, data);
        return response.data;
    },
    async getAllRequestsForPaymentDocument(_, { params }) {
        const response = await paymentDocumentsAPI.getAllRequestsForPaymentDocumentAPI(params);
        return { data: response.data._embedded['request'], total: response.data['bz:total_records'] || 0 };
    },
    async addRequestsToPaymentDocument(_, { data }) {
        const response = await paymentDocumentsAPI.addRequestsToPaymentDocumentAPI({ requestIds: data.requestIds });
        return response.data;
    },
    async updateRequestsOfPaymentDocument(_, { paymentDocumentId, data }) {
        const response = await paymentDocumentsAPI.updateRequestsOfPaymentDocumentAPI(paymentDocumentId, data);
        return response.data;
    },
    async getRequestsOfPaymentDocument(_, paymentDocumentId) {
        const response = await paymentDocumentsAPI.getRequestsOfPaymentDocumentAPI(paymentDocumentId);
        return response.data;
    },
    async removeRequestsFromPaymentDocument(_, { paymentDocumentId, data }) {
        const response = await paymentDocumentsAPI.removeRequestsFromPaymentDocumentAPI(paymentDocumentId, data);
        return response.data;
    },
    async getAllPaymentDocuments(_, params) {
        const response = await paymentDocumentsAPI.getAllPaymentDocumentsAPI(params);
        return {
            data: response.data._embedded['payment-document'],
            total: response.data['bz:total_records'] || 0,
            totalPages: response.data['bz:total_pages'] || 0,
        };
    },
    async getPaymentDocumentById(_, paymentDocumentId) {
        const response = await paymentDocumentsAPI.getPaymentDocumentByIdAPI(paymentDocumentId);
        return response.data;
    },
    async uploadPaymentDocumentAttachment(_, { paymentDocumentId, type, data }) {
        const response = await paymentDocumentsAPI.uploadPaymentDocumentAttachmentAPI(paymentDocumentId, type, data);
        return response.data;
    },
    async getAttachmentsOfPaymentDocument(_, paymentDocumentId) {
        const response = await paymentDocumentsAPI.getAttachmentsOfPaymentDocumentAPI(paymentDocumentId);
        return response.data;
    },
    async downloadPaymentDocumentAttachment(_, attachmentId) {
        const response = await paymentDocumentsAPI.downloadPaymentDocumentAttachmentAPI(attachmentId);
        return response.data;
    },
    async deletePaymentDocumentAttachment(_, attachmentId) {
        const response = await paymentDocumentsAPI.deletePaymentDocumentAttachmentAPI(attachmentId);
        return response.data;
    },
    async getAllStatusOfPaymentDocument(_, paymentDocumentId) {
        const response = await paymentDocumentsAPI.getAllStatusOfPaymentDocumentAPI(paymentDocumentId);
        return response.data;
    },
    async submitPaymentDocument(_, paymentDocumentId) {
        const response = await paymentDocumentsAPI.submitPaymentDocumentAPI(paymentDocumentId);
        return response.data;
    },
    async createPaymentDocumentComment(_, { paymentDocumentId, data }) {
        const response = await paymentDocumentsAPI.createPaymentDocumentCommentAPI(paymentDocumentId, data);
        return response.data;
    },
    async getPaymentDocumentComment(_, paymentDocumentId) {
        const response = await paymentDocumentsAPI.getPaymentDocumentCommentAPI(paymentDocumentId);
        return response.data;
    },
    async deletePaymentDocumentComment(_, commentId) {
        const response = await paymentDocumentsAPI.deletePaymentDocumentCommentAPI(commentId);
        return response.data;
    },
    async getPaymentDocumentFilterOptions({ commit }) {
        const response = await paymentDocumentsAPI.getPaymentDocumentFilterOptionsAPI();
        if (response.data) {
            commit('setFilterOptions', response.data);
        }
        return response.data;
    },
    async downloadPaymentDocumentReport(_, params) {
        const response = await paymentDocumentsAPI.downloadPaymentDocumentReportAPI(params);
        return response.data;
    },
    async acceptPaymentDocumentReview(_, { paymentDocumentId, type }) {
        const body = {
            actionType: type,
        };
        const response = await paymentDocumentsAPI.acceptPaymentDocumentReview(paymentDocumentId, body);
        return response.data;
    },
    async rejectPaymentDocumentReview(_, paymentDocumentId) {
        const response = await paymentDocumentsAPI.rejectPaymentDocumentReview(paymentDocumentId);
        return response.data;
    },
    async cancelPaymentDocumentProcessing(_, paymentDocumentId) {
        const response = await paymentDocumentsAPI.cancelPaymentDocumentProcessing(paymentDocumentId);
        return response.data;
    },
    async cancelPaymentDocument(_, data) {
        const body = {
            comment: data.comment,
        };
        const response = await paymentDocumentsAPI.cancelPaymentDocument(data.paymentDocumentId, body);
        return response.data;
    },
    async approveReversalOfRequestInPaymentDocument(_, { paymentDocumentId, requestId, sapReversalCode }) {
        const response = await paymentDocumentsAPI.approveReversalOfRequestInPaymentDocument(paymentDocumentId, requestId, sapReversalCode);
        return response.data;
    },
    async rejectReversalOfRequestInPaymentDocument(_, { paymentDocumentId, requestId }) {
        const response = await paymentDocumentsAPI.rejectReversalOfRequestInPaymentDocument(paymentDocumentId, requestId);
        return response.data;
    },
    async syncPaymentDocument(_, paymentDocumentId) {
        const response = await paymentDocumentsAPI.syncPaymentDocumentAPI(paymentDocumentId);
        return response.data;
    },
    async deletePaymentDocument(_, paymentDocumentId) {
        const response = await paymentDocumentsAPI.deletePaymentDocumentAPI(paymentDocumentId);
        return response.data;
    },
};

export default {
    state,
    mutations,
    actions,
};
